export const brand = {
    /** #000 */
    actualBlack: '#000',
    /** #282828 */
    black: '#282828',
    /** #666666 */
    charcoal: '#666666',
    /** #425563 */
    darkCoral: '#425563',
    /** #F0F0F0 */
    lightGrey: '#F0F0F0',
    /** #A3A3A3 */
    midGrey: '#A3A3A3',
    /** #F8A554 */
    orange: '#F8A554',
    /** #fff */
    white: '#fff',
    green: {
        /** #EEF5DA */
        beige: '#EEF5DA',
        /** #009636 */
        dark: '#009636',
        /** #D6EEDE */
        honey: '#D6EEDE',
        /** #D7DF23 */
        light: '#D7DF23',
        /** #539B6B */
        medium: '#539B6B',
        /** #9DBE41 */
        mid: '#9DBE41',
        /** #EBF7EF */
        mint: '#EBF7EF',
        /** #B3DCC1 */
        seafoam: '#B3DCC1',
        /** #D9E9AD */
        tea: '#D9E9AD',
    },
    validation: {
        invalid: '#da291c',
        valid: '#008c15',
    },
};
export var ThemeOption;
(function (ThemeOption) {
    ThemeOption["Default"] = "default";
    ThemeOption["DarkCoral"] = "darkCoral";
    ThemeOption["GreenBeige"] = "greenBeige";
    ThemeOption["GreenMint"] = "greenMint";
    ThemeOption["Grey"] = "grey";
})(ThemeOption || (ThemeOption = {}));
export var ButtonIcon;
(function (ButtonIcon) {
    ButtonIcon["Arrow"] = "circle-arrow-right";
    ButtonIcon["SpeechBubble"] = "speech-bubble";
})(ButtonIcon || (ButtonIcon = {}));
export var BannerThemeOption;
(function (BannerThemeOption) {
    BannerThemeOption["DarkCoral"] = "darkCoral";
    BannerThemeOption["GreenSeafoam"] = "greenSeafoam";
    BannerThemeOption["GreenTea"] = "greenTea";
    BannerThemeOption["GreenDark"] = "greenDark";
})(BannerThemeOption || (BannerThemeOption = {}));
export var IconThemeOption;
(function (IconThemeOption) {
    IconThemeOption["Grey"] = "grey";
    IconThemeOption["Green"] = "green";
})(IconThemeOption || (IconThemeOption = {}));
